import { createFileRoute } from '@tanstack/react-router'

import LearnpathsElementRouter from '@/learnpaths-assigned-element/components/LearnpathsElementRouter'

export const Route = createFileRoute(
  '/_learning/learnpaths/$learnpathId/$elementId/$topic/$lecture/{-$suffix}',
)({
  component: LearnpathsElementRouter,
})
